import { getSpeedquizInstancesForLoggedInUser } from '../Services/speedquiz';
import { ObjectType } from '../Types/base';
import { useBizQuery } from './useBizQuery';

const QUERYKEY_SPEEDQUIZES = 'SPEEDQUIZES_FOR_LOGGED_IN_USER';

export const useGetSpeedquizInstancesForLoggedInUser = (objectType?: ObjectType, objectId?: number) => {
	const { data, statusState } = useBizQuery([QUERYKEY_SPEEDQUIZES, { objectType, objectId }], () =>
		getSpeedquizInstancesForLoggedInUser(objectType, objectId)
	);
	return {
		data: data || [],
		statusState,
	};
};
